@if (src(); as src) {
  <iframe [src]="src" inert></iframe>
  @if (muted()) {
    <svg class="filter-definitions" aria-hidden="true">
      <filter [attr.id]="mutedFilterId" color-interpolation-filters="sRGB">
        <feColorMatrix type="matrix" [attr.values]="mutedColorMatrix" />
      </filter>
    </svg>
    @for (tile of mutedTiles(); track $index) {
      <div
        class="muted-tile"
        [style.left.px]="tile.x"
        [style.top.px]="tile.y"
        [style.width.px]="tile.width"
        [style.height.px]="tile.height"
      ></div>
    }
  }
}
